export const SAVED_SEARCH_WEBHOOKS_QUERY_KEY = "saved-search-webhooks:list";
export const ACCOUNT_SEARCHES_QUERY_KEY = "saved-search-webhooks:account-searches";
export const SAVE_SAVED_SEARCH_WEBHOOK_MUTATION_KEY = "saved-search-webhooks:save";
export const REMOVE_SAVED_SEARCH_WEBHOOK_MUTATION_KEY = "saved-search-webhooks:remove";
export const TEST_SAVED_SEARCH_WEBHOOK_MUTATION_KEY = "saved-search-webhooks:test";
